var map = {
	"./company-placeholder.png": 223,
	"./user.jpg": 7712,
	"./user1.png": 555,
	"./user2.png": 1013,
	"./user3.png": 8179,
	"./user4.png": 491,
	"./user5.png": 9415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;